import { DateBox } from "devextreme-react";
import React from "react";
import { useForm } from "react-hook-form";

const ComplainForm = ({ onSubmit, defaultValues, applicant }) => {
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });
  

  return (
    <div className="container mt-4" style={{ maxWidth: "625px" }}>
      <h5 className="es-label-title">{defaultValues && Object.keys(defaultValues).length > 0 ? "Edit Complain" : "Create Complain"}</h5>
      <div className="card p-3">
      <div className="row mb-0">
        <div className="col-md-8">          
          <div className="es-field-label-black">   
              <div>
                  <br></br>
                  <p style={{ marginBottom: "5px" }}>Full Name : <strong style={{ paddingLeft: "33px" }}>{applicant ? applicant.fullName : "Loading..."}</strong></p>
                  <p style={{ marginBottom: "5px" }}>Passport No : <strong style={{ paddingLeft: "22px" }}>{applicant ? applicant.passportNo : "Loading..."}</strong></p>
                  <p style={{ marginBottom: "5px" }}>Gender : <strong style={{ paddingLeft: "52px" }}>{applicant ? applicant.gender : "Loading..."}</strong></p>
                  <p style={{ marginBottom: "5px" }}>Occupation : <strong style={{ paddingLeft: "28px" }}>{applicant ? applicant.occupation : "Loading..."}</strong></p>
              </div>
            </div>
        </div>
        <div className="col-md-4 d-flex justify-content-center">
          <div className="row">
          {applicant && (
              <div className="p-1 bg-gray-100 rounded">
                {applicant?.photo && (
                  <img
                    src={`data:image/jpeg;base64,${applicant.photo}`}
                    alt="Applicant Photo"
                    className="rounded-full"
                    style={{ width: "135px", height: "140px", borderColor: "darkgray", borderStyle: "solid", borderWidth: "thin" }} // Adjust size as needed
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>     
      <hr/>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-1">
      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Date</label>
            <div className="col-sm-8">
                <DateBox
                    className="es-dx-field"
                    value={watch("complainDate")}
                    displayFormat="dd/MM/yyyy" // Ensures proper date format
                    placeholder="DD/MM/YYYY"  // Watermark
                    onValueChanged={(e) => setValue("complainDate", e.value)}
                    min={new Date("2000-01-01")}
                />
                {errors.complainDate && (<i className="bi bi-exclamation-circle text-danger ms-0"></i>)}
            </div>
          </div>
        </div>
      </div>      

      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Complained By :</label>
            <div className="col-sm-8">
                <input type="text" {...register("complainedBy", { required: "Required", maxLength: 50 })} className="form-control w-full border p-1 rounded" />
                {errors.complainedBy && <p className="text-red-500 text-sm">{errors.complainedBy.message}</p>}
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Phone No. :</label>
            <div className="col-sm-8">
                  <input type="text" {...register("contactPhone", { maxLength: 20 })} className="form-control w-full border p-1 text-sm rounded h-8" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Relation :</label>
            <div className="col-sm-8">
                <input type="text" {...register("relation", { maxLength: 20 })} className="form-control w-full border p-1 rounded" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Type :</label>
            <div className="col-sm-8">
            <select {...register("complainType")} className="form-control w-full border p-1">
                <option value=""></option>
                <option value="Call Issue">Call Issue</option>
                <option value="Salary Issue">Call Issue</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Description :</label>
            <div className="col-sm-8">
                <input type="text" {...register("description", { maxLength: 255 })} className="form-control w-full border p-1 rounded es-field-label-black" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-0">
        <div className="col-md-12">
          <div className="row">
            <label className="col-sm-4 col-form-label es-field-label">Status :</label>
            <div className="col-sm-8">
            <select {...register("status")} className="form-control w-full border p-1">
                <option value=""></option>
                <option value="COMPLAIN">COMPLAIN</option>
                <option value="ON PROGRESS">ON PROGRESS</option>
                <option value="RESOLVED">RESOLVED</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      
      <div className="d-flex justify-content-end">
            <button type="submit" className="btn es-button">
              SAVE
            </button>
          </div>
      </form>
      </div>
    </div>
  );
};

export default ComplainForm;